<template>
  <el-popover width="400" trigger="click" placement="right" :width="400">
    <div slot="reference">
      <el-button type="primary" size="small" @click="visible = !visible">停止充电</el-button>
    </div>
    <div style="padding: 20px 0;">
      <div style="font-size: 16px; font-weight: bold; margin-bottom: 16px; text-align: center;">停止充电</div>
      <el-radio-group v-model="stopMode" @change="handleStopModeChange">
        <el-radio label="immediate" style="display: block; margin-bottom: 16px;">
          立即停止充电
        </el-radio>
        <el-radio label="soc" style="display: block; margin-bottom: 16px;">
          预设停止充电
          <span style="margin-left: 16px;">SOC</span>
          <el-input-number v-model="targetSoc" :min="0" :max="100" :step="1" size="small"
            style="width: 120px; margin: 0 8px;" />
          <span>%</span>
        </el-radio>
        <el-radio label="power" style="display: block; margin-bottom: 16px;">
          预设充电充电
          <span style="margin-left: 16px;">电量</span>
          <el-input-number v-model="targetPower" :min="0" :max="1023" :step="10" size="small"
            style="width: 120px; margin: 0 8px;" />
          <span>Kwh</span>
        </el-radio>
      </el-radio-group>
      <div style="display: flex; justify-content: center; margin-top: 20px;">
        <el-button @click="handleCancel" style="margin-right: 16px;">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确定</el-button>
      </div>
    </div>
  </el-popover>
</template>

<script>
import { controlEncrypt } from '@/utils/encrypt';

export default {
  name: 'StopChargeDialog',
  props: {
    VehicleID: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      visible: false,
      stopMode: 'immediate', // 停止模式：immediate(立即停止)，soc(指定SOC后停止)，power(指定电量后停止)
      targetSoc: 80, // 目标SOC值
      targetPower: 600 // 目标电量值
    };
  },
  methods: {
    handleStopModeChange() {
      // 模式切换时的处理
      console.log('Stop mode changed to:', this.stopMode);
    },
    handleCancel() {
      // Popover会自动关闭
    },
    handleConfirm() {
      // 处理停止充电设置
      var confirmText = {
        VehicleID: this.VehicleID,
        cmdCode: "6",
        AppFlag: 2, // 1：从APP，2：从web
        params: {
          ScheduledType: "4",
          ScheduledMode: "1",
          StopCharge: "1",
          StopChargeSoc: "",
          ChargeCapacity: ""
        }
      };

      if (this.stopMode === 'soc') {
        confirmText.params.StopCharge = "0";
        confirmText.params.StopChargeSoc = this.targetSoc.toString();
      } else if (this.stopMode === 'power') {
        confirmText.params.StopCharge = "0";
        confirmText.params.ChargeCapacity = this.targetPower.toString();
      }

      const ciphertextPara = controlEncrypt(confirmText);
      this.$api.realtimeControl(ciphertextPara)
        .then((res) => {
          if (res.code == 200) {
            this.$message({
              message: this.$t('tree.下发成功'),
              type: "success",
            });
            // Popover会自动关闭
          }
        })
        .catch((e) => {
          console.error('停止充电设置失败:', e);
        });

      console.log('Handle stop charge:', {
        stopMode: this.stopMode,
        targetSoc: this.targetSoc,
        targetPower: this.targetPower,
        VehicleID: this.VehicleID
      });
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: center;
}
</style>